import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import Modal from '../../../../components/Modal/Modal';
import Table from '../../../../components/Table/Table';
import TableHead from '../../../../components/Table/TableHead';
import TableRow from '../../../../components/Table/TableRow';
import TableHeadData from '../../../../components/Table/TableHeadData';
import TableBody from '../../../../components/Table/TableBody';
import TableData from '../../../../components/Table/TableData';
import Text from '../../../../components/Text/Text';
import getCoMissingParts from '../../../../thunks/coilovers/orders/getCoMissingParts';
import Input from '../../../../components/Input/Input';
import postCoMissingParts from '../../../../thunks/coilovers/orders/postCoMissingParts';
import getCoOrders from '../../../../thunks/coilovers/orders/getCoOrders';
import coOrderStatus from '../../../../constants/coOrderStatus';

const modalBodyClassName = 'w-[500px] overflow-auto px-[10px]';
const tableContainerClassName = 'overflow-auto';
const tableCellClassName = 'min-w-max whitespace-nowrap px-[9px] py-0';

const CoMissingPartsModal = ({
  visible,
  toggleVisible,
  orderId
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const {
    getCoMissingParts: {
      loading,
      data: {
        items: data = [],
        need_release: needRelease,
        order_status: orderStatus,
      } = {},
    } = {},
  } = useSelector((state) => ({
    getCoMissingParts: state?.getCoMissingParts,
  }), shallowEqual);

  const {
    values,
    setFieldValue,
    submitForm,
    resetForm,
  } = useFormik({
    initialValues: {},
    onSubmit: (a) => {
      dispatch(postCoMissingParts({
        items: a,
        orderId,
        needRelease
      }))
        .then(() => {
          enqueueSnackbar('Item(s) updated successfully', { variant: 'success' });
          toggleVisible?.();
          dispatch(getCoOrders());
        });
    }
  });

  useEffect(() => {
    if (visible) {
      dispatch(getCoMissingParts({ id: orderId }));
    }
  }, [visible]);

  useEffect(() => {
    if (data.length) {
      resetForm();
      data?.map((item) => setFieldValue(`${item?.id}`, { ...item }));
    }
  }, [data]);

  return (
    <Modal
      visible={visible}
      toggleVisible={toggleVisible}
      title="Missing Parts"
      subTitle={`Order ID: ${orderId}`}
      onSave={submitForm}
      canSave={loading || !Object.keys(values).length}
    >
      <div className={`${modalBodyClassName} customScroll`}>
        <div className={tableContainerClassName}>
          <Table loading={loading}>
            <TableHead>
              <TableRow>
                <TableHeadData>
                  MPN
                </TableHeadData>
                <TableHeadData>
                  in order
                </TableHeadData>
                <TableHeadData>
                  ware
                </TableHeadData>
                <TableHeadData>
                  correct
                </TableHeadData>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((item) => {
                const {
                  id,
                  mpn,
                  qtyToReserved,
                  part_whs_total_qty: total,
                } = item;
                return (
                  <TableRow key={id}>
                    <TableData className={tableCellClassName}>
                      <Text text={`${mpn}`} />
                    </TableData>
                    <TableData className={tableCellClassName}>
                      <Text text={`${qtyToReserved}`} />
                    </TableData>
                    <TableData className={tableCellClassName}>
                      <div className="flex justify-center items-center">
                        {(orderStatus === coOrderStatus.PACK_BOX
                          || orderStatus === coOrderStatus.PART_BOX
                          || orderStatus === coOrderStatus.PICKED)
                          ? total + qtyToReserved : total}
                      </div>
                    </TableData>
                    <TableData className={tableCellClassName}>
                      <div className="flex justify-center items-center">
                        <Input
                          name={`${id}.correct`}
                          onChange={({ target: { value } }) => {
                            setFieldValue(`${id}`, { ...item, correct: value });
                          }}
                          value={values[`${id}`]?.correct || ''}
                          type="number"
                        />
                      </div>
                    </TableData>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      </div>
    </Modal>
  );
};

CoMissingPartsModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
  orderId: PropTypes.string
};

CoMissingPartsModal.defaultProps = {
  visible: false,
  toggleVisible: () => {
  },
  orderId: ''
};
export default CoMissingPartsModal;
